import {Fill, Icon, Stroke, Style, Text} from "ol/style";
import {url} from "../../utilities";

export const huntersPointsStyle = (feature) => {
    return new Style({
        image: new Icon({
            src: url(`images/selected-device-type-${feature.get('device_type')}.png`),
            anchor: [0.5, 1],
            size: [20, 23]
        }),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'center',
            text: feature.get('name'),
            offsetY: 8,
            fill: new Fill({color: 'white'}),
            stroke: new Stroke({color: 'rgb(128, 18, 10)', width: 2}),
            placement: 'point',
            font: '12px sans-serif',
            overflow: false,
        }),
    })
}

export const selectedHuntersPointsStyle = (feature) => {
    return new Style({
        image: new Icon({
            src: url(`images/hunter-point.png`),
            anchor: [0.5, 1],
            size: [20, 23]
        }),
        text: new Text({
            textAlign: 'center',
            textBaseline: 'center',
            text: feature.get('name'),
            offsetY: 8,
            fill: new Fill({color: 'black'}),
            stroke: new Stroke({color: 'rgb(0, 0, 0)', width: 2}),
            placement: 'point',
            font: '12px sans-serif',
            overflow: false,
        }),
    })
}

export const farHuntersPointsStyle = (feature) => {
    return new Style({
        image: new Icon({
            src: url(`images/hunter-point.png`),
            anchor: [0.5, 1],
            size: [0, 0]
        })
    });
}
